import React from 'react'

const NonBrokingSection = () => {
    return (
        <>
            <section id="steps">
                <div className="container">
                    <div className="text-center">
                        <h2>Effortless Onboarding in 3 Simple Steps</h2>
                    </div>
                    <div className="dflex spacebetween mobflexwrap">
                        <div className="d30">
                            <div className="borderbox right">
                                <div className="bluebox ">Enter Client’s Name</div>
                            </div>
                        </div>
                        <div className="d30">
                            <div className="borderbox right">
                                <div className="bluebox">Mobile number</div>
                            </div>
                        </div>
                        <div className="d30">
                            <div className="borderbox">
                                <div className="bluebox">Select City</div>
                            </div>
                        </div>
                    </div>
                    <div className="mtop40" />
                    <div className="text-center f22">Tailored Solutions for Your Clients</div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="text-center">
                        <h2>
                            Looking for a product specially crafted for IINIs and family
                            offices?Alternate Investment Funds (AIF) is the perfect choice!
                        </h2>
                        <p className="f20">
                            AIFs are privately pooled investment vehicles that raise funds from
                            both Indian and foreign investors. AIFs invest in a wide range of
                            alternative assets, such as private equity, venture capital, real
                            estate, hedge funds, and more
                        </p>
                    </div>
                </div>
                <div className="mtop50" />
                <div className="container">
                    <div className="text-center">
                        <h2>Why Choose AIFs?</h2>
                    </div>
                    <div className="dflex justifycenter gap50 mobflexwrap">
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/returns.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">
                                Potential for higher returns
                            </div>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/family.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">
                                Popular among HNIs and family officers
                            </div>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/diversification.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">Diversification</div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="text-center">
                        <h2>Types of AIFs</h2>
                    </div>
                    <div className="dflex spacebetween mobflexwrap">
                        <div className="d32">
                            <div className="topbluebox text-center">
                                <div className="blueblox">Category I AIFs</div>
                                <div className="whtbox">
                                    <div className="f20 semibold">
                                        Focus: Sectors with social or economic benefits
                                    </div>
                                    <div className="mtop15" />
                                    <div className="f16">
                                        <strong>Example:</strong> Venture capital funds, angel funds,
                                        SME funds, social venture funds, infrastructure funds
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d32">
                            <div className="topbluebox text-center">
                                <div className="blueblox">Category II AIFs</div>
                                <div className="whtbox">
                                    <div className="f20 semibold">
                                        Focus: Investments that don’t fall under Category I or III
                                    </div>
                                    <div className="mtop15" />
                                    <div className="f16">
                                        <strong>Example:</strong> Private equity funs, real estate
                                        funds, distressed assets funds, fund of funds
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d32">
                            <div className="topbluebox text-center">
                                <div className="blueblox">Category III AIFs</div>
                                <div className="whtbox">
                                    <div className="f20 semibold">
                                        Focus: Listed and unlisted securities with complex strategies
                                    </div>
                                    <div className="mtop15" />
                                    <div className="f16">
                                        <strong>Example:</strong> Hedge funds, long-short funds
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="greybg">
                <div className="container">
                    <div className="text-center">
                        <h2>
                            Need expert portfolio management for your client? Choose Portfolio
                            Management Services (PMS) today?
                        </h2>
                        <p className="f20">
                            PMS is tailored investment solutions for high net worth individuals
                            (HNIs) and institutional investors, where a professional portfolio
                            manager designs and overseas the investment based on the client’s
                            financial goals, risk tolerance, and investment horizon
                        </p>
                    </div>
                    <div className="mtop40" />
                    <div className="text-center">
                        <div className="text-center">
                            <h2>Why Choose PMS?</h2>
                        </div>
                    </div>
                    <div className="dflex justifycenter gap50 mobflexwrap">
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/personalized.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">Personalized Portfolio</div>
                            <p>Tailored to individual financial goals and risk tolerance</p>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/management.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">
                                Higher Returns Potential
                            </div>
                            <p>Designed to maximize growth opportunities.</p>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/returns.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">Active Management</div>
                            <p>Professional fund managers monitor and adjust portfolios. </p>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/diversification.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">Diversification</div>
                            <p>Spreads investments across various asset classes to reduce risk</p>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="text-center">
                        <p className="f20">
                            Looking to safeguard your client’s future? Insurance has got you
                            covered! Explore insurance today and help your clients protect their
                            loved ones from the unforeseen future.
                        </p>
                    </div>
                    <div className="mtop40" />
                    <div className="text-center f22 semibold">
                        Types of Insurance in India
                    </div>
                    <div className="mtop40" />
                    <div className="dflex justifycenter gap50 mobflexwrap">
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/lifeinsurance.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">Life Insurance</div>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/healthinsurance.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">Health Insurance</div>
                        </div>
                        <div className="col">
                            <div className="imgblock text-center">
                                <img src="https://ekyc.motilaloswal.com/EKYC_Icons/nonBroking/generalinsurance.svg" alt />
                            </div>
                            <div className="contentbox f20 semibold">General Insurance</div>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <div className="container f16 text-center semibold">
                    <div className="whitecolor">On-boarding process made easier.</div>
                </div>
            </footer>
        </>
    )
}

export default NonBrokingSection